import styled from 'styled-components/macro';

import H1 from '../../../atoms/H1';

export const PageTitle = styled(H1)`
  text-align: center;
  margin: 30px 0;
  font-size: 36px;
`;

export default PageTitle;
